import { useEffect, useRef } from "react";
import "./SessionWarningModal.scss";
import Spinner from "../Spinner/Spinner";
import Buttons from "../Buttons/Buttons";

const formatCountdown = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};

const SessionWarningModal = ({
  open,
  countdown,
  onStayLoggedIn,
  isLoggingOut,
}) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) {
      dialog.showModal();
    } else if (!open && dialog.open) {
      dialog.close();
    }
  }, [open]);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return undefined;
    // This guards a session-timeout countdown, so it isn't Escape-dismissible.
    const handleCancel = (e) => e.preventDefault();
    dialog.addEventListener("cancel", handleCancel);
    return () => dialog.removeEventListener("cancel", handleCancel);
  }, []);

  const title =
    countdown > 0
      ? "Session Expiring"
      : isLoggingOut
        ? "Logging Out"
        : "Session Expired";

  return (
    <dialog
      ref={dialogRef}
      className="session-warning-modal"
      aria-labelledby="session-warning-title"
    >
      <div className="session-warning-header">
        <h2 id="session-warning-title">{title}</h2>
      </div>
      <div className="session-warning-content">
        {isLoggingOut ? (
          <>
            <p>You are being logged out. Please wait...</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Spinner />
            </div>
          </>
        ) : countdown > 0 ? (
          <>
            <p>Your session is about to expire due to inactivity.</p>
            <div className="countdown-timer">
              <div className="countdown-circle">
                <span className="countdown-number">
                  {formatCountdown(countdown)}
                </span>
                <span className="countdown-label">remaining</span>
              </div>
            </div>
            <p className="countdown-text">
              You will be logged out in{" "}
              <strong>{formatCountdown(countdown)}</strong>
            </p>
          </>
        ) : (
          <>
            <p>Your session has expired. Please log in again.</p>
            <div className="countdown-timer">
              <div className="countdown-circle">
                <span className="countdown-number">00:00</span>
                <span className="countdown-label">expired</span>
              </div>
            </div>
          </>
        )}
      </div>
      {!isLoggingOut && (
        <div className="session-warning-footer">
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            <Buttons
              text="Stay Logged In"
              type="button"
              variant="secondary"
              fullWidth={false}
              onClick={onStayLoggedIn}
            />
          </div>
        </div>
      )}
    </dialog>
  );
};

export default SessionWarningModal;
